import cn from 'classnames'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Page from '../../components/page/Page'
import { useSharedState } from '../../components/waxplorer/Waxplorer'

const ImprintPage = (props) => {
    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const { t } = useTranslation('common')

    useEffect(() => {}, [userName])

    return (
        <Page id="ImprintPage">
            <div className={cn('h-full w-full my-auto text-base')}>
                <div
                    className={cn(
                        'text-white m-auto w-1/2 block text-left justify-center',
                    )}
                >
                    <h3>{t('footer.imprint')}</h3>
                    <div>Hive Digital UG</div>
                    <div>HRB209881</div>
                    <div>Germany</div>
                    <br />
                    <div>
                        E-Mail:{' '}
                        <a
                            className="text-bluel"
                            href="mailto:admin@nfthive.io"
                        >
                            admin@nfthive.io
                        </a>
                    </div>
                    <div>
                        Block Producer:{' '}
                        <a className="text-bluel" href="https://hivebp.io">
                            https://hivebp.io
                        </a>
                    </div>
                </div>
            </div>
        </Page>
    )
}

export default ImprintPage
